<template>

    <div class="bg">
        <el-row>
            <el-card class="box-card">
                <div slot="header" class="clearfix">
                    <span style="font-weight:bold;font-size:20px">构建系统新用户注册</span>
                </div>
                <el-form :model="user" status-icon :rules="rules" ref="user" label-width="100px" class="demo-ruleForm" size="mini">
                    <el-form-item label="用户名" prop="userName">
                        <el-input type="text" placeholder="请输入QQ号" v-model="user.userName" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="密码" prop="password">
                        <el-input type="password" placeholder="请输入密码" v-model="user.password" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="姓名" prop="userRealName">
                        <el-input type="text" placeholder="真实姓名" v-model="user.userRealName"></el-input>
                    </el-form-item>
                    <el-form-item label="手机号" prop="phoneNo">
                        <el-input placeholder="手机号" v-model="user.phoneNo" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="邮箱" prop="email">
                        <el-input placeholder="邮箱，例：abc@qq.com" v-model="user.email"></el-input>
                    </el-form-item>
                    <el-form-item label="单位" prop="unit">
                        <el-input placeholder="单位" v-model="user.unit"></el-input>
                    </el-form-item>
                    <el-form-item label="组织部门" prop="deptName">
                        <el-input placeholder="组织部门" v-model="user.deptName"></el-input>
                    </el-form-item>
                    <el-form-item label="职称" prop="post">
                        <el-input placeholder="职称" v-model="user.post"></el-input>
                    </el-form-item>
                    <el-form-item label="导师/上级" prop="parentName">
                        <el-input placeholder="导师/上级" v-model="user.parentName"></el-input>
                    </el-form-item>
                    <el-form-item label="营业执照" prop="businessLicense">
                        <el-input placeholder="营业执照" v-model="user.businessLicense"></el-input>
                    </el-form-item>
                    <el-form-item label="公司存续状态" prop="survivalStatus">
                        <el-input placeholder="公司存续状态" v-model="user.survivalStatus"></el-input>
                    </el-form-item>
                    <el-form-item label="收货地址" prop="survivalStatus">
                        <el-input placeholder="收货地址" v-model="user.address"></el-input>
                    </el-form-item>
                    <el-form-item label-width="0px">
                        <el-button type="primary" @click="userRegister('user')">注册</el-button>
                    </el-form-item>
                </el-form>
                <el-link type="primary" @click="toLogin">返回登录</el-link>
            </el-card>
        </el-row>
    </div>
    
</template>

<script>
    import GlobeConstant from '../../assets/js/GlobeConstant.js';

    export default {
        name:'User',
        components: {
        },
        data() {
             var validateUserName = (rule, value, callback) => {
                 if(value) {
                     let reg = /^[0-9]{1,20}$/
                     if(!reg.test(value)) {
                         callback(new Error("请输入正确的QQ号"));
                     }
                 }
                 callback();
            };
            // var validatePassword = (rule, value, callback) => {
            //     if(value) {
            //         let reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[a-zA-Z0-9]{8,20}$/
            //         if(!reg.test(value)) {
            //             callback(new Error("密码必须包含字母和数字，长度为8-20位"));
            //         }
            //     }
            //     callback();
            // };
            var validatePhoneNo = (rule, value, callback) => {
                if(!value) {
                    callback();
                } else {
                    let reg = /^1(3\d|4[5-9]|5[0-35-9]|6[567]|7[0-8]|8\d|9[0-35-9])\d{8}$/
                    if(!reg.test(value)) {
                        callback(new Error("请输正确的手机号"));
                    }
                }
                callback();
            };  
            return {
                user:{},
                drawer: false,
                direction: 'rtl',
                users: [],
                currentPage: 1,
                pageSize:10,
                total:10,
                timer:'',
                userProp:{},
                title:"新增用户",
                dataStatuses:[],
                dialogFormVisible: false,
                formLabelWidth:"120px",
                updateUser: {
                    userId: "",
                },
                currentUserId: "",
                rules: {
                    userName: [
                        { required: true, message: "请输入用户名", trigger: "blur" },
                        { validator: validateUserName, trigger: "blur" }
                    ],
                    userRealName: [
                        { required: true, message: "请输入真实姓名", trigger: "blur" },
                        { min: 1, max: 20, message: "长度在 1 到 20 个字符", trigger: "blur" }
                    ],
                    password: [
                        { required: true, message: "请输入密码", trigger: "blur" },
                    ],
                    phoneNo: [
                        { required: true, message: "请输手机号", trigger: "blur" },
                        { validator: validatePhoneNo, trigger: "blur" }
                    ],
                    email: [
                        { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }
                    ],
                },
                loading: true,
                tableHeight: "",//表格高度
            }
        },
        methods: {
            userRegister(formName) {
                this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.$axios.post("/login/register", this.user).then(res => {
                        if (res.data.status === "success") {
                            this.$message({
                                message: "注册成功！",
                                type: "success"
                            });
                            this.$router.push("/login");
                        } else {
                            this.$message.error(res.data.message);
                        }
                    }, error => {
                        this.$message.error(error.message);
                    });
                } else {
                    return false;
                }
                });
            },
            handleSizeChange(val) {
                this.currentPage = 1;
                this.pageSize = val;
                this.queryUser();
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.queryUser();
            },
            handleClose(done) {
                this.$confirm('确认关闭？')
                .then(()=> {
                    done();
                    this.queryUser();
                })
                .catch(() => {});
            },
            queryUser() {
                this.loading = true;
                this.user.pageNum = this.currentPage;
                this.user.pageSize = this.pageSize;
                this.$axios.post("/user/findUserTree",this.user).then(
                    res=>{
                        if(res.data.status === "success"){
                            this.users = res.data.result;
                        } else {
                            this.$message.error(res.data.message);
                        }
                        this.loading = false;
                    },
                    error=>{
                        this.$message.error(error.message);
                    }
                )
            },
            createUser() {
                this.title = "新增用户";
                this.drawer = true;
                this.timer = new Date().getTime();
                this.userProp = {};
            },
            closeDrawer() {
                this.drawer = false;
                this.queryUser();
            },
            updatePassword(row) {
                this.currentUserId = row.userId;
                this.dialogFormVisible = true;
                var formName = 'resetPassword';
                if(this.$refs[formName]) {
                    this.$refs[formName].resetFields();
                }
            },
            doUpdatePassword(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.updateUser.userId = this.currentUserId;
                        this.$axios.post("/login/setPassword",this.updateUser).then(
                            res=>{
                                if(res.data.status === "success"){
                                    this.$message.success("密码重置成功！");
                                    this.dialogFormVisible = false;
                                } else {
                                    this.$message.error(res.data.message);
                                }
                            },
                            error=>{
                                this.$message.error(error.message);
                            }
                        )
                    } else {
                        return false;
                    }
                });
                
            },
            getTableHeight() {
                let tableH = 260; //距离页面下方的高度
                this.tableHeight = window.innerHeight - tableH;
            },
            toLogin() {
                this.$router.push("/login");
            }
        },
        mounted() {
            this.$bus.$on(GlobeConstant.userupdate_to_user_close, this.closeDrawer);
        },
        beforeDestroy() {
            this.$bus.$off(GlobeConstant.userupdate_to_user_close);
        },
        created() {
            this.getTableHeight();
        }
        
    }


</script>

<style scoped>

   .el-form {
       margin-top: 10px;
   }
   .block {
       text-align: right;
       margin-top: 10px;
   }

    .box-card {
        width: 800px;
        position : absolute;
        margin-top: 20px;
        margin-left: 25%;
    }
    .bg {
        width: 100%;
        height: 100%;
        position: absolute;
        /* background: url("~@/assets/loginImage.png"); */
        background-size: 100% 100%;
    }
    .el-button {
        width:100%;
    }

</style>
